export interface State {
  payload: any;
  errorData: any;
  loading: boolean;
  success: boolean;
}

export const initialState: State = {

  payload: {
    id: null,
    url: null,
  },
  errorData: null,
  success: false,
  loading: false,
};
